import toast from "react-hot-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";
import { useHandleNetworkError } from "utils/useHandleNetworkError";

export const useAddSocialWelfareECert = ({ onSuccess }) => {
  const queryClient = useQueryClient();

  const handleNetworkError = useHandleNetworkError(
    "Error adding social welfare E-Cert"
  );

  const tenantVal = localStorage.getItem("kinesin-tenant");

  return useMutation({
    meta: { skipGlobalError: true },
    mutationFn: async (values) => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.post(
        `${tenantVal}/healthlink/deasp-form`,
        {
          patientId: values.patientId,
          consultationDateTime: values.consultationDateTime,
          certificateType: values.certificateType,
          sickFromDate: values.sickFromDate,
          ...(values.durationWeeks !== undefined
            ? { durationWeeks: values.durationWeeks }
            : { sickToDate: values.sickToDate }),
          natureOfConditionCode: values.natureOfConditionCode,
          physicalEffort: values.physicalEffort,
          hospitalized: values.hospitalized,
          final: values.final,
        }
      );

      return response.data;
    },
    onSuccess: () => {
      toast.success("Social Welfare E-Cert added successfully!");
      queryClient.invalidateQueries({ queryKey: ["patientDeaspCertificates"] });
      onSuccess?.();
    },
    // Surface the specific rejection reason from the backend (e.g. missing
    // Healthlink consent, panel/config problems) instead of a generic toast
    // (KIN-1378 / KIN-1379). 403 keeps the shared logout/redirect behaviour.
    onError: (error) => {
      if (error?.response?.status === 403) {
        handleNetworkError(error);
        return;
      }

      console.error(error);

      const responseData = error?.response?.data;
      const specificMessage =
        (typeof responseData === "string" ? responseData : null) ||
        responseData?.message ||
        responseData?.error;

      toast.error(specificMessage || "Error adding social welfare E-Cert");
    },
  });
};
